'use client';

import React from 'react';
import LayoutDefault from '../../layouts/LayoutDefault';

interface AssetManageTestProps {
  onClose: () => void;
  isSidebarOpen: boolean;
}

export default function AssetManageTest({ onClose, isSidebarOpen }: AssetManageTestProps) {
  return (
    <LayoutDefault onClose={onClose} isSidebarOpen={isSidebarOpen}>
      <div className="h-screen overflow-hidden bg-[#F8F8F8] flex">
        {/* Test Content */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Header */}
          <div className="bg-[#ECECEC] px-6 py-8">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-8">
                <h1 className="text-[28px] font-bold uppercase text-black tracking-wide">
                  TEST COMPONENT - QUẢN LÝ HIỆN VẬT
                </h1>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 overflow-y-auto p-6">
            <div className="bg-white rounded-lg p-8 shadow-sm">
              <h2 className="text-xl font-semibold mb-4">Component được load thành công!</h2>
              
              <div className="space-y-4">
                <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
                  <h3 className="font-medium text-green-800">✅ Component AssetManage đã được mount</h3>
                  <p className="text-green-600 text-sm mt-1">
                    Nếu bạn thấy thông báo này, nghĩa là component đã được load đúng cách.
                  </p>
                </div>
                
                <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
                  <h3 className="font-medium text-blue-800">🔍 Các bước troubleshoot:</h3>
                  <ul className="text-blue-600 text-sm mt-2 space-y-1 list-disc list-inside">
                    <li>Kiểm tra console browser để xem có error không</li>
                    <li>Kiểm tra Network tab để xem API calls</li>
                    <li>Đảm bảo idPath đã được set trong context</li>
                    <li>Kiểm tra API token và endpoints</li>
                  </ul>
                </div>

                <div className="p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                  <h3 className="font-medium text-yellow-800">⚡ Demo Component</h3>
                  <p className="text-yellow-600 text-sm mt-1">
                    Sử dụng "Demo Hiện vật" để xem giao diện với mock data.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutDefault>
  );
}
